import { FC, ReactNode } from 'react'
import {
  MembershipProfileTagAvatar,
  MembershipProfileTagAvatarType,
} from './Avatar'
import {
  MembershipProfileTagOption,
  MembershipProfileTagOptionType,
} from './Option'
import { MembershipProfileTagType, Tag } from './Tag'

const MembershipProfileTag: FC &
  MembershipProfileTagAvatarType &
  MembershipProfileTagOptionType &
  MembershipProfileTagType = (): ReactNode => <></>

MembershipProfileTag.Avatar = MembershipProfileTagAvatar
MembershipProfileTag.Option = MembershipProfileTagOption
MembershipProfileTag.Tag = Tag

export default MembershipProfileTag
